import { render, staticRenderFns } from "./practiceTest.vue?vue&type=template&id=0dbee308&scoped=true"
import script from "./practiceTest.vue?vue&type=script&lang=js"
export * from "./practiceTest.vue?vue&type=script&lang=js"
import style0 from "./practiceTest.vue?vue&type=style&index=0&id=0dbee308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbee308",
  null
  
)

export default component.exports